module.exports = __webpack_public_path__ + "img/no_hatching_infographic.cc668605.svg";